var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "查看员工",
            visible: _vm.drawer,
            direction: "rtl",
            size: "75.7%",
            "append-to-body": "",
            "custom-class": "drawer my-drawer",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "padding-left": "24px" } },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "custom-tabs2",
                  on: { "tab-click": _vm.toggleTab },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                _vm._l(_vm.tags, function (item, index) {
                  return _c("el-tab-pane", {
                    key: index,
                    attrs: { label: item.label, name: item.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.activeName == 1
            ? _c(
                "div",
                { staticClass: "main" },
                [
                  _c("emplpyment-detail", { attrs: { detail: _vm.detail } }),
                  _c("div", { staticClass: "back" }, [
                    _c(
                      "div",
                      {
                        staticClass: "back-btn",
                        on: {
                          click: function ($event) {
                            _vm.drawer = false
                          },
                        },
                      },
                      [_vm._v("返回")]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName == 2
            ? _c("div", { staticClass: "main" }, [
                _c("div", { staticClass: "title" }, [_vm._v("角色权限")]),
                _c(
                  "div",
                  { staticClass: "main-content" },
                  [
                    _c(
                      "el-form",
                      {
                        staticClass: "form",
                        attrs: {
                          inline: true,
                          size: "small",
                          "label-width": "82px",
                          "label-position": "right",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-right": "197px" },
                            attrs: { label: "钉钉角色：" },
                          },
                          [
                            _vm.detail.autoRoleName &&
                            _vm.detail.autoRoleName.length > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  _vm._l(
                                    _vm.detail.autoRoleName,
                                    function (item, index) {
                                      return _c("div", [
                                        _vm._v(" " + _vm._s(item)),
                                        index !=
                                        _vm.detail.autoRoleName.length - 1
                                          ? _c("span", [_vm._v(",")])
                                          : _vm._e(),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _c("div", [_vm._v("--")]),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "OA角色" } },
                          [
                            _c(
                              "el-select",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.roleDataList.length > 0,
                                    expression: "roleDataList.length>0",
                                  },
                                ],
                                attrs: {
                                  placeholder: "",
                                  multiple: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.detail.roleIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "roleIds", $$v)
                                  },
                                  expression: "detail.roleIds",
                                },
                              },
                              _vm._l(_vm.roleDataList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }